export default __webpack_public_path__ + "static/media/our-culture-bg.2b86eca9.svg";